export function isInRange (num: number | boolean | null, from: number, to: number): boolean {
  const n = parseInt(`${num}`)
  return Number.isSafeInteger(num) && n > 0 && n >= from && n <= to
}

export function isIntInRange (val: number, min: number | undefined, max: number | undefined): boolean {
  if (!Number.isFinite(val) || !Number.isSafeInteger(val)) {
    return false
  } else if (min !== undefined && val < min) {
    return false
  } else if (max !== undefined && val > max) {
    return false
  }
  return true
}

export function finiteNumberOrNull (value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null
}

// Clamps `n` into [min, max] (NaN passes through unchanged, matching Math.min/max).
export function clamp (n: number, min: number, max: number): number {
  return Math.min(Math.max(n, min), max)
}

// Clamps `n` into [0, 1].
export function clamp01 (n: number): number {
  return clamp(n, 0, 1)
}
